module.exports = __webpack_public_path__ + "static/img/03.0a2c6553.png";